import GeofenceService from '@/api/services/geofence.service';
import IGeofence from '@/models/dto/IGeofence';
import store from '@/store/index';
import { geofences } from '@/utils/mockup-api-geofences';
import { Map } from 'ol';
import { Action, getModule, Module, Mutation, VuexModule } from 'vuex-module-decorators';

@Module({ dynamic: true, store, name: 'geofences' })
class Geofences extends VuexModule {
    //STORE
    geofences: IGeofence[] = geofences
    map: Map = new Map();

    @Mutation
    setMap(newMap: Map): void {
        this.map = newMap;
    }

    //MUTATIONS
    @Mutation
    setGeofences(geofences: any[]): void {
        this.geofences = geofences
    }

    @Mutation
    addGeofence(geofence: IGeofence): void {
        this.geofences.push(geofence)
    }

    @Action({ commit: 'setGeofences' })
    async getAllGeofences() {
        const data = (await GeofenceService.getAll()).data
        console.log(data)
        return data
    }

}
export default getModule(Geofences);